import { render, staticRenderFns } from "./edit-message-form.vue?vue&type=template&id=7fcf728d&scoped=true"
import script from "./edit-message-form.vue?vue&type=script&lang=js"
export * from "./edit-message-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcf728d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fcf728d')) {
      api.createRecord('7fcf728d', component.options)
    } else {
      api.reload('7fcf728d', component.options)
    }
    module.hot.accept("./edit-message-form.vue?vue&type=template&id=7fcf728d&scoped=true", function () {
      api.rerender('7fcf728d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/edit-message-form.vue"
export default component.exports